<div class="header-container">
  <h3>Multi-Location Administrators</h3>
  <div class="header-container-actions">
    <button matButton="elevated" class="charcoal-button" (click)="openMlAdminModal()">ADD MULTI-LOCATION ADMIN</button>
    <mat-divider class="header-container-actions-divider" [vertical]="true"></mat-divider>
    <button matIconButton (click)="expandCurtain = !expandCurtain">
      <mat-icon>{{ expandCurtain ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
  </div>
</div>
<mat-divider></mat-divider>
<div [class.hidden]="!expandCurtain" class="p-20">
  @if (mlAdminService.loadingMlAdminList()) {
    <div class="w-full flex justify-center items-center p-20">
      <mat-spinner diameter="20" class="mr-10" />
      <span class="text-red">Loading...</span>
    </div>
  }
  <table [dataSource]="dataSource" mat-table matSort matSortActive="username">
    @for (row of columnInfos; track row) {
      <ng-container [matColumnDef]="row?.matColumnDef">
        <th
          mat-header-cell
          mat-sort-header
          *matHeaderCellDef
          [disabled]="row?.matColumnDef === 'kebab' || row?.matColumnDef === 'status'">
          {{ row?.columnTitle }}
        </th>
        <td mat-cell *matCellDef="let item">
          @if (!['status', 'kebab', 'repairerSites'].includes(row?.matColumnDef)) {
            <span>
              {{ item[row?.property] }}
            </span>
          }
          @if (row?.matColumnDef === 'repairerSites') {
            <div>
              {{ getRepairerSiteNames(item) }}
            </div>
          }
          @if (row?.matColumnDef === 'status') {
            <app-status-cell-info [data]="item" [currentUserTimezone]="currentUserService.timeZone">
            </app-status-cell-info>
          }
          @if (row?.matColumnDef === 'kebab') {
            <mat-panel-description class="kebab-panel">
              <div class="secondary-icon flex justify-end">
                <button matIconButton [matMenuTriggerFor]="revokeTokenMenu" (click)="$event.stopPropagation()">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #revokeTokenMenu="matMenu" class="kebab-menu">
                  @for (button of kebabButtons; track button) {
                    @if (item.status !== button.status && item.isActivated === button.activatedToDisplay) {
                      <button mat-menu-item (click)="onClickKebabButton(button.status, item.username)">
                        {{ button.label }}
                      </button>
                    }
                  }
                </mat-menu>
              </div>
            </mat-panel-description>
          }
        </td>
      </ng-container>
    }

    <tr *matHeaderRowDef="columnHeaders" mat-header-row></tr>
    <tr *matRowDef="let row; columns: columnHeaders" mat-row (click)="openMlAdminModal(row)"></tr>
  </table>
</div>
